module.exports = {"settings":{"nameEn":"ชื่อ (ภาษาอังกฤษ)","nameTh":"ชื่อ (ภาษาไทย)","address":"ที่อยู่","email":"อีเมล","groupName":"ชื่อ","groupCode":"รหัส","groupDescription":"รายละเอียด","stationIds":"รหัสสถานี","firstName":"ชื่อ","lastName":"นามสกุล","age":"อายุ","password":"รหัสผ่าน","userGroupId":"กลุ่มผู้ใช้งาน","companyId":"บริษัท","siteId":"สถานที่","station":"สถานี","add":"เพิ่ม","stationName":"ชื่อสถานี","siteName":"ชื่อสถานที่","status":"สถานะ"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/settings.json
// module id = 118
// module chunks = 35